document.addEventListener('DOMContentLoaded', () => {
  const labels = ['made with care', 'heirloom quality', 'premium materials', 'classic styling'];
  const groups = [...document.querySelectorAll('.product-details .group-block')];
  const benefitsGroup = groups
    .filter((group) => {
      const text = group.innerText.toLowerCase().replace(/\s+/g, ' ').trim();
      return labels.every((label) => text.includes(label));
    })
    .sort((a, b) => a.innerText.length - b.innerText.length)[0];

  benefitsGroup?.remove();
});
